module.exports = __webpack_public_path__ + "../static/img/synapse-icon.7e79af41.png";